import React from 'react';
import {Form, Textarea, List} from 'components';
import {useNamedSelector} from 'helpers';

export function Health() {
  return (
    <Form {...useNamedSelector('clarity.form', { name: 'health' })}>
      <List tiny-gutter>
        <List.Title>Describe your ideal state of health</List.Title>
        <Textarea single name="1" />
        <List.Title>What do you feel like/what does the world look like when you are living in an ideal state of health?</List.Title>
        <Textarea single name="2" />
        <List.Title>What is standing in the way of reaching your desired state of health?</List.Title>
        <Textarea single name="3" />
        <List.Title>What are you afraid to admit to yourself about your current state of health?</List.Title>
        <Textarea single name="4" />
        <List.Title>What are your most common excuses for not taking care of yourself?</List.Title>
        <Textarea single name="5" />
        <List.Title>What was your family's attitude toward health/fitness/nutrition?</List.Title>
        <Textarea single name="6" />
        <List.Title>Who in your life supports a healthy you and who undermines it?</List.Title>
        <Textarea single name="7" />
        <List.Title>What would change in your life if you were healthier?</List.Title>
        <Textarea single name="8" />
      </List>
    </Form>
  );
}
